import React, { useState } from 'react';

export function MobileQuickActions() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 md:hidden">
      {isOpen && (
        <div className="flex flex-col gap-3 mb-4 items-end">
          <button className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-lg border border-gray-100 text-sm font-medium text-gray-700 hover:bg-gray-50">
            <span>📝</span> New Session
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-lg border border-gray-100 text-sm font-medium text-gray-700 hover:bg-gray-50">
            <span>🚨</span> Trigger Alert
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-lg border border-gray-100 text-sm font-medium text-gray-700 hover:bg-gray-50">
            <span>✅</span> End Session
          </button>
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-indigo-600 text-white rounded-full shadow-xl flex items-center justify-center text-2xl hover:bg-indigo-700 focus:outline-none transition-transform"
        style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
      >
        +
      </button>
    </div>
  );
}
